import { useEffect, useState } from 'react';

const CLEARSALE_SESSION_KEY = 'clearSaleSessionId';

export function useClearSaleSession(appKey) {
  const [clearSaleSessionId, setClearSaleSessionId] = useState(null);
  const [clearSaleIsReady, setClearSaleIsReady] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    // garante sessionId por sessão
    let id = sessionStorage.getItem(CLEARSALE_SESSION_KEY);

    if (!id) {
      id = crypto.randomUUID();
      sessionStorage.setItem(CLEARSALE_SESSION_KEY, id);
    }

    setClearSaleSessionId(id);

    // aguarda o script carregar (caso ainda não esteja pronto)
    const waitForCsdp = () => {
      if (window.csdp) {
        window.csdp('app', appKey);
        window.csdp('sessionid', id);
        setClearSaleIsReady(true);
        return;
      }

      setTimeout(waitForCsdp, 100);
    };

    waitForCsdp();
  }, [appKey]);

  return {
    clearSaleSessionId,
    clearSaleIsReady,
  };
}
